module.exports = __webpack_public_path__ + "assets/img/45@3x.c4a8c0e5.png";